<template>
    <div class="insp">
        <div class="insp_title">
            <div style="display: flex;">
                <div class="title">签章检验</div>
                <div class="btn" :class="isInsp == 0 ? 'btnActive' : ''" @click="isInsp = 0; getData()">待检测</div>
                <div class="btn" :class="isInsp == 1 ? 'btnActive' : ''" @click="isInsp = 1; getData()">已检测</div>
            </div>
            <div class="search">
                <el-input v-model="search" placeholder="请输入合同标题" clearable @change="handlSearch"></el-input>
                <div class="btn" @click="handlSearch">搜索</div>
            </div>
        </div>
        <div class="insp_mess">
            <div class="conTemp" v-for="(item,index) in waitData" :key="index" v-show="isInsp == 0"
                 @mouseenter="enters(item)"
                 @mouseleave="leaver(item)">
                <div class="contract">
                    <img :src="item.url"/>
                    <div class="contractHover" v-show="item.isZhe"></div>
                </div>
                <div class="title" :class="item.isZhe ? 'titleHover' : ''">{{item.title}}</div>
                <div class="con_btn">
                    <div class="btn" :class="item.isZhe ? 'btnActive' : ''"
                         @click="$router.push({name:'uploadInsp',params:{path:item.contactPath,id:item.id}})">上传检验
                    </div>
                </div>
            </div>

            <div>
                <div class="conTemp" v-for="(newItem,newIndex) in waitData" :key="newIndex" v-show="isInsp == 1"
                     @mouseenter="enters(newItem)"
                     @mouseleave="leaver(newItem)">
                    <div class="contract">
                        <img :src="newItem.url"/>
                        <div class="contractHover" v-show="newItem.isZhe"></div>
                    </div>
                    <div class="title" :class="newItem.isZhe ? 'titleHover' : ''">{{newItem.title}}</div>
                    <div class="con_btn">
                        <div class="inspBtn" :class="newItem.isZhe ? 'btnActive' : ''">
                            <div class="text1">检验通过</div>
                            <div class="text2">检验时间：{{newItem.signTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                search: '',
                isInsp: 0,
                waitData: []
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData(title) {
                let _this = this;
                let param = new FormData();
                if (title) {
                    param.append('title', title);
                }
                param.append('token', _this.$global.token);
                param.append('checkState', this.isInsp);

                _this.api.getContactCheckList(param).then(res => {
                    res.data.forEach((item, index) => {
                        item.url = require('../../../../static/img/contar-11.png')
                        item.isZhe = false
                    })
                    _this.waitData = res.data;
                    console.log(res);
                })
            },
            handlSearch() {
                this.getData(this.search);
            },
            enters(item) {
                item.isZhe = true;
            },
            leaver(item) {
                item.isZhe = false;
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .insp {
        width: @a;
        height: auto;
        margin-left: 4%;

        .insp_title {
            width: 1073px;
            height: 40px;
            display: @flex;
            align-items: center;
            justify-content: space-between;

            .title {
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                margin-right: 13px;
            }

            .search {
                width: 370px;
                height: 40px;
                margin-left: 123px;
                display: flex;
                justify-content: flex-end;

                .btn {
                    width: 80px;
                    height: 40px;
                    background-color: #f5f5f5;
                    border: solid 1px #aaaaaa;
                    letter-spacing: 1px;
                    color: #333333;
                    font-size: 16px;
                    margin: 0;
                    @row();
                    cursor: pointer;
                }
            }

            .btn {
                width: 120px;
                height: 40px;
                background-color: #fff;
                border: solid 1px #aaaaaa;
                margin-left: 20px;
                letter-spacing: 1px;
                color: #333333;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                font-size: 16px;
            }

            .btnActive {
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                color: #fff;
            }
        }

        .insp_mess {
            width: 1073px;
            height: auto;

            // overflow: hidden;
            .conTemp:first-child {
                margin-left: 0;
            }

            .conTemp:nth-child(4n + 1) {
                margin-left: 0;
            }

            .conTemp {
                width: 245px;
                height: auto;
                display: inline-block;
                position: relative;
                margin: 31px 0 0 31px;
                padding: 0 3px;

                .contractHover {
                    width: 245px;
                    height: 340px;
                    position: absolute;
                    top: 0;
                    left: 3.5px;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#ffffff,
                    #ffffff);
                    background-blend-mode: normal,
                    normal;
                    opacity: 0.4;
                }

                .contract {
                    width: 245px;
                    height: auto;
                    background-color: #ffffff;
                    border: solid 1px #aaaaaa;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: cover;
                    }
                }

                .titleHover {
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#f5f5f5,
                    #f5f5f5);
                    background-blend-mode: normal,
                    normal;
                    color: #fff !important;
                }

                .title {
                    width: 245px;
                    height: auto;
                    background-color: #f5f5f5;
                    border: solid 1px #aaaaaa;
                    border-top: 0;
                    text-align: center;
                    line-height: 46px;
                    letter-spacing: 1px;
                    color: #333333;
                    font-size: 18px;
                }

                .con_btn {
                    width: 245px;
                    height: auto;
                    margin-top: 5px;

                    .btnActive {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        color: #fff !important;
                    }

                    .btn {
                        width: 245px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        background-color: #f2f2f2;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 18px;
                        cursor: pointer;
                    }

                    .inspBtn {
                        width: 245px;
                        height: 70px;
                        background-color: #f2f2f2;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 18px;
                        @column();
                        cursor: pointer;

                        .text1 {
                            font-family: MicrosoftYaHei;
                            font-size: 18px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 1px;
                            width: @a;
                            height: 18px;
                            text-align: center;
                        }

                        .text2 {
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 1px;
                            margin-top: 10px;
                            width: @a;
                            height: 14px;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/signature/sign_insp.vue